import { render, staticRenderFns } from "./PortalSection.vue?vue&type=template&id=050f2648&scoped=true&"
import script from "./PortalSection.vue?vue&type=script&lang=js&"
export * from "./PortalSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f2648",
  null
  
)

export default component.exports